import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = [
    'progressBar',
    'sendFaxButton',
    'generatingStatus',
    'sendFaxForm',
    'toNumber',
    'toNumberManual',
    'fromNumber',
    'errorMessage',
  ];

  mockProgress(event) {
    if (this.sendFaxFormTarget.checkValidity() && this.validateNumbers()) {
      this.errorMessageTarget.classList.add('d-none');
      this.sendFaxButtonTarget.disabled = true;
      this.generatingStatusTarget.classList.remove('d-none');
      this.sendFaxFormTarget.submit();

      setInterval(() => {
        const progress = Number(this.progressBarTarget.style.width.replace('%', ''));
        if (progress < 95) {
          this.progressBarTarget.style.width = `${progress + 5}%`;
        } else {
          this.progressBarTarget.style.width = '98%';
        }
      }, 500);
    } else {
      event.preventDefault();
      this.errorMessageTarget.classList.remove('d-none');
    }
  }

  validateNumbers() {
    let toNumber;

    if (this.getNumberValue(this.toNumberTarget)) {
      toNumber = this.getNumberValue(this.toNumberTarget);
    } else {
      toNumber = this.getNumberValue(this.toNumberManualTarget);
    }

    const fromNumber = this.getNumberValue(this.fromNumberTarget);
    if (toNumber && fromNumber) {
      return toNumber.match(/\d/g).length === 10 && fromNumber.match(/\d/g).length === 10;
    }

    return false;
  }

  getNumberValue(numberElement) {
    return numberElement.value || numberElement.getAttribute('value');
  }
}
